import React, {useState} from 'react';
import {Tabs, Tab, Card} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './event-details.scss';
import PersonExposedTab from './person-exposed-tab';
import {
  personExposedEnum,
  EventStatusEnum,
  EventStatusIds,
  parseEventStatusForForm,
} from '../../../../../utils/constants';
import {useDispatch} from 'react-redux';
import {Formik, Form} from 'formik';
import CustomSelect from '../../../../../components/form/customSelect/customSelect';
import Button from '../../../../../components/form/button/button';
import {toast} from 'react-toastify';
import {
  saveEventDetail,
  updateEventDetail,
} from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import Loader from '../../../../../components/loader/loader';

function eventDetailMatchesRoute(detail, eventId, riskAssessmentId) {
  if (detail === undefined) {
    return false;
  }
  if (Object.keys(detail).length === 0) {
    return true;
  }
  const taskOk =
    detail.event_task == null ||
    String(detail.event_task) === String(eventId);
  const raOk =
    riskAssessmentId == null ||
    riskAssessmentId === '' ||
    detail.parent_risk_assessment == null ||
    String(detail.parent_risk_assessment) === String(riskAssessmentId);
  return taskOk && raOk;
}

const FailureMode = ({
  eventId,
  riskAssessmentId,
  eventDetail,
  fetchEventDetail,
  readOnly,
}) => {
  const dispatch = useDispatch();

  const [personType, setPersonType] = useState(1);

  const handleInputChange = value => {
    setPersonType(value);
  };

  const statusFormReady = eventDetailMatchesRoute(
    eventDetail,
    eventId,
    riskAssessmentId,
  );

  const handleSaveStatus = values => {
    const payload = {
      event_status: Number(values.event_status),
      removed_notes: values.removed_notes || '',
      action_required_by: eventDetail?.action_required_by || [],
      media: (eventDetail?.media_details || []).map(item => item.id),
      parent_risk_assessment:
        riskAssessmentId ?? eventDetail?.parent_risk_assessment,
      event_task: eventId,
    };

    const onSuccess = result => {
      if (result?.status === 200 || result?.status === 201) {
        toast.success('Status saved successfully.', {
          autoClose: 2000,
          className: 'toast-success',
        });
        fetchEventDetail();
      } else {
        toast.error('Failed to save status. Please try again.', {
          autoClose: 2000,
          className: 'toast-error',
        });
      }
    };

    if (eventDetail?.id) {
      dispatch(
        updateEventDetail({
          id: eventDetail.id,
          payload,
          callback: onSuccess,
        }),
      );
    } else {
      dispatch(
        saveEventDetail({
          payload,
          callback: onSuccess,
        }),
      );
    }
  };

  return (
    <div className="py-5">
      <h3 className="mb-4 fw-bold">
        Person Exposed
      </h3>
      <Card className="failure-mode-card">
        <Card.Body>
          <Tabs
            activeKey={personType}
            id="person-type-tabs"
            className="mb-3"
            justify
            onSelect={k => handleInputChange(k)}
            unmountOnExit
            mountOnEnter>
            {personExposedEnum.map(person => (
              <Tab key={person.id} eventKey={person.id} title={person.name}>
                <PersonExposedTab
                  personType={person.id}
                  eventId={eventId}
                  riskAssessmentId={riskAssessmentId}
                />
              </Tab>
            ))}
          </Tabs>
        </Card.Body>
      </Card>

      <Card className="failure-mode-card mt-3">
        <Card.Body>
          {!statusFormReady ? (
            <div className="py-4 d-flex justify-content-center">
              <Loader />
            </div>
          ) : (
            <Formik
              enableReinitialize
              initialValues={{
                event_status: parseEventStatusForForm(eventDetail?.event_status),
                removed_notes: eventDetail?.removed_notes ?? '',
              }}
              onSubmit={handleSaveStatus}
            >
              {({values, setFieldValue}) => (
                <Form>
                  <CustomSelect
                    label={'Event has been'}
                    options={EventStatusEnum}
                    name={'event_status'}
                    value={values.event_status}
                    handleChange={e => {
                      const v = e.target.value;
                      setFieldValue(
                        'event_status',
                        v === '' ? EventStatusIds.NotStarted : Number(v),
                      );
                    }}
                    showError={true}
                    disabled={readOnly}
                  />
                  {!readOnly && (
                    <div className="action-buttons mt-3">
                      <Button type="submit" variant="submit-button">
                        Save
                      </Button>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default FailureMode;
